module.exports = __webpack_public_path__ + "img/liked.18f0be89.png";